import { createRouter, createWebHashHistory } from 'vue-router'
import open from '@/layout/open'
import open1 from '@/layout/open1'
import platform from '@/layout/platform'
import datav from "@/layout/Datav";

const openRoutes = [
    {
        path: '/login',
        component: open,
        redirect: '/login',
        name: "login",
        meta: { title: '登录', classify: 'login', icon: 'login', affix: true, isHistoryNav:0,isShow: 0 },
        children: [
            {
                path: '/login',
                component: () => import('@/views/login/index'),
                name: 'login',
                meta: { title: '登录', classify: 'login', icon: 'login', affix: true,isHistoryNav:0, isShow: 0 }
            }
        ]
    },
    {
        path: '/loginLogistics',
        component: open,
        redirect: '/loginLogistics',
        name: "loginLogistics",
        meta: { title: '物流管理员-登录', classify: 'loginLogistics', icon: 'loginLogistics', affix: true, isHistoryNav:0,isShow: 0 },
        children: [
            {
                path: '/loginLogistics',
                component: () => import('@/views/loginLogistics/index'),
                name: 'loginLogistics',
                meta: { title: '物流管理员-登录', classify: 'loginLogistics', icon: 'loginLogistics', affix: true,isHistoryNav:0, isShow: 0 }
            }
        ]
    },
    {
        path: '/loginEmployee',
        component: open,
        redirect: '/loginEmployee',
        name: "loginEmployee",
        meta: { title: '员工-登录', classify: 'loginEmployee', icon: 'loginEmployee', affix: true, isHistoryNav:0,isShow: 0 },//员工-登录
        children: [
            {
                path: '/loginEmployee',
                component: () => import('@/views/loginEmployee/index'),
                name: 'loginEmployee',
                meta: { title: '员工-登录', classify: 'loginEmployee', icon: 'loginEmployee', affix: true,isHistoryNav:0, isShow: 0 }//员工-登录
            }
        ]
    },
    {
        path: '/loginSelect',
        component: open,
        redirect: '/loginSelect',
        name: "loginSelect",
        meta: { title: '欧力液压系统（嘉兴）有限公司', classify: 'loginSelect', icon: 'loginSelect', affix: true, isHistoryNav:0,isShow: 0 },
        children: [
            {
                path: '/loginSelect',
                component: () => import('@/views/loginSelect/index'),
                name: 'loginSelect',
                meta: { title: '欧力液压系统（嘉兴）有限公司', classify: 'loginSelect', icon: 'loginSelect', affix: true,isHistoryNav:0, isShow: 0 }
            }
        ]
    },
    {
        path: '/files/fileLists/:no',
        component: open1,
        redirect: '/files/fileLists',
        name: "fileLists",
        meta: { title: '磨具证书列表', classify: 'login', icon: 'login', affix: true, isHistoryNav:0,isShow: 1 },
        children: [
            {
                path: '/files/fileLists/:no',
                component: () => import('@/views/files/fileLists'),
                name: 'fileLists',
                meta: { title: '磨具证书列表', classify: 'fileLists', icon: 'fileLists', affix: true,isHistoryNav:0, isShow: 1 }
            }
        ]
    },
]
const importRoutes = filterByKey([
    {
        path: "/import",
        component: platform,
        redirect: "/import",
        name: "import",
        meta: {
            title: "数据导入",
            classify: "import",
            icon: "import",
            affix: true,
            level: 5,
            isShow: 1,
            authClassify: "import",
            table: "",
        },
        children: [
            {
                path: "/import",
                component: () => import("@/views/import/index"),
                name: "printIndex",
                meta: {
                    title: "数据导入",
                    classify: "import",
                    icon: "import",
                    affix: true,
                    level: 5,
                    isShow: 1,
                    authClassify: "import",
                    table: "",
                },
            },
            {
                path: "/upload/:type",
                component: () => import("@/views/import/upload"),
                name: "uploadIndex",
                meta: {
                    title: "导入数据",
                    classify: "print",
                    icon: "print",
                    affix: true,
                    level: 5,
                    isShow: 1,
                    authClassify: "print",
                    table: "",
                },
            },{
                path: "/upload1/:type",
                component: () => import("@/views/import/upload1"),
                name: "uploadIndex1",
                meta: {
                    title: "导入数据",
                    classify: "print",
                    icon: "print",
                    affix: true,
                    level: 5,
                    isShow: 1,
                    authClassify: "print",
                    table: "",
                },
            },
        ],
    },
]);


const toolsRoutes1 = [
    {
        path: '/',
        component:platform,
        redirect: '/home',
        name: "home",
        meta: { title: '首页', classify: 'home', icon: 'home', affix: true,isHistoryNav:0, isShow: 1,authClassify: "home", },
        children: [
            {
                path: '/home',
                component: () => import('@/views/home/index'),
                name: 'homeIndex',
                meta: { title: '首页', classify: 'home', icon: 'home', affix: true,isHistoryNav:0, isShow: 1 }
            }
        ]
    },
    {
        path: "/datav",
        component: datav,
        redirect: "/datav/all",
        name: "datav",
        meta: {
            title: "活动数据",
            classify: "datav",
            icon: "datav",
            affix: true,
            isHistoryNav: 0,
            isShow: 1,
            role: 10,
            authClassify: "datav",
        },
        children: filterByKey([
            {
                path: "all",
                component: () => import("@/views/datav/all"),
                name: "datavIndex",
                meta: {
                    title: "数据统计",
                    classify: "datav",
                    icon: "datav",
                    affix: true,
                    isHistoryNav: 0,
                    isShow: 1,
                    role: 10,
                    authClassify: "datav",
                },
            },
        ]),
    },
]


const employeeRoutes = filterByKey([
    {
        path: '/employee',
        component:platform,
        redirect: '/employee/index',
        name: "employee",
        meta: { title: '员工管理', classify: 'employee', icon: 'employee', affix: true,isHistoryNav:1, isShow: 1 ,authClassify:"employee"},
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/employee/index'),
                name: 'employeeIndex',
                meta: { title: '员工管理', classify: 'employee', icon: 'employee',isHistoryNav:1, affix: true, isShow: 1,authClassify:"employee" }
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/employee/detail'),
                name: 'employeeDetail',
                meta: { title: '员工详情', classify: 'employee', icon: 'employee',isHistoryNav:0, affix: true, isShow: 1 ,authClassify:"employee"}
            }
        ])
    },
])

const emailRoutes = filterByKey([
    {
        path: '/email',
        component:platform,
        redirect: '/email/index',
        name: "email",
        meta: { title: '邮箱管理', classify: 'email', icon: 'email', affix: true,isHistoryNav:1, isShow: 1 ,authClassify:"email"},
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/email/index'),
                name: 'emailIndex',
                meta: { title: '邮箱管理', classify: 'email', icon: 'email',isHistoryNav:1, affix: true, isShow: 1,authClassify:"email" }
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/email/detail'),
                name: 'emailDetail',
                meta: { title: '邮箱详情', classify: 'email', icon: 'email',isHistoryNav:0, affix: true, isShow: 1 ,authClassify:"email"}
            }
        ])
    },
])

const deviceRoutes = filterByKey([
    {
        path: '/device',
        component:platform,
        redirect: '/device/index',
        name: "device",
        meta: { title: '检具清单', classify: 'device', icon: 'device', affix: true,isHistoryNav:1, isShow: 1 ,authClassify:"device"},
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/device/index'),
                name: 'deviceIndex',
                meta: { title: '检具清单', classify: 'device', icon: 'device',isHistoryNav:1, affix: true, isShow: 1,authClassify:"device" }
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/device/detail'),
                name: 'deviceDetail',
                meta: { title: '检具清单', classify: 'device', icon: 'device',isHistoryNav:0, affix: true, isShow: 1,authClassify:"device" }
            }
        ])
    },
])

const deviceOneRoutes = filterByKey([
    {
        path: '/deviceOne',
        component:platform,
        redirect: '/deviceOne/index',
        name: "deviceOne",
        meta: { title: '压力表&压力容器&安全阀', classify: 'deviceOne', icon: 'deviceOne', affix: true,isHistoryNav:1, isShow: 1 ,authClassify:"deviceOne"},
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/deviceOne/index'),
                name: 'deviceOneIndex',
                meta: { title: '压力表&压力容器&安全阀', classify: 'deviceOne', icon: 'deviceOne',isHistoryNav:1, affix: true, isShow: 1,authClassify:"deviceOne" }
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/deviceOne/detail'),
                name: 'deviceOneDetail',
                meta: { title: '压力表&压力容器&安全阀', classify: 'deviceOne', icon: 'deviceOne',isHistoryNav:0, affix: true, isShow: 1,authClassify:"deviceOne" }
            }
        ])
    },
])

const deviceTwoRoutes = filterByKey([
    {
        path: '/deviceTwo',
        component:platform,
        redirect: '/deviceTwo/index',
        name: "deviceTwo",
        meta: { title: '扭力扳手&气动扳手', classify: 'deviceTwo', icon: 'deviceTwo', affix: true,isHistoryNav:1, isShow: 1 ,authClassify:"deviceTwo"},
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/deviceTwo/index'),
                name: 'deviceTwoIndex',
                meta: { title: '扭力扳手&气动扳手', classify: 'deviceTwo', icon: 'deviceTwo',isHistoryNav:1, affix: true, isShow: 1,authClassify:"deviceTwo" }
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/deviceTwo/detail'),
                name: 'deviceTwoDetail',
                meta: { title: '扭力扳手&气动扳手', classify: 'deviceTwo', icon: 'deviceTwo',isHistoryNav:0, affix: true, isShow: 1,authClassify:"deviceTwo" }
            }
        ])
    },
])

const deviceThreeRoutes = filterByKey([
    {
        path: '/deviceThree',
        component:platform,
        redirect: '/deviceThree/index',
        name: "deviceThree",
        meta: { title: '常规量具清单', classify: 'deviceThree', icon: 'deviceThree', affix: true,isHistoryNav:1, isShow: 1 ,authClassify:"deviceThree"},
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/deviceThree/index'),
                name: 'deviceThreeIndex',
                meta: { title: '常规量具清单', classify: 'deviceThree', icon: 'deviceThree',isHistoryNav:1, affix: true, isShow: 1,authClassify:"deviceThree" }
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/deviceThree/detail'),
                name: 'deviceThreeDetail',
                meta: { title: '常规量具清单', classify: 'deviceThree', icon: 'deviceThree',isHistoryNav:0, affix: true, isShow: 1,authClassify:"deviceThree" }
            }
        ])
    },
])

const taskRoutes = filterByKey([
    {
        path: '/task',
        component:platform,
        redirect: '/task/index',
        name: "task",
        meta: { title: '派发任务', classify: 'task', icon: 'task', affix: true,isHistoryNav:1, isShow: 1 ,authClassify: "task" },
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/task/index'),
                name: 'taskIndex',
                meta: { title: '派发任务', classify: 'task', icon: 'task',isHistoryNav:1, affix: true, isShow: 1,authClassify: "task" }
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/task/detail'),
                name: 'taskDetail',
                meta: { title: '派发任务详情', classify: 'task', icon: 'task',isHistoryNav:0, affix: true, isShow: 1,authClassify: "task" }
            }
        ])
    },
])

const departmentRoutes = filterByKey([
    {
        path: '/department',
        component:platform,
        redirect: '/department/index',
        name: "department",
        meta: { title: '量具部门', classify: 'department', icon: 'department', affix: true,isHistoryNav:1, isShow: 1 ,authClassify: "department" },
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/department/index'),
                name: 'departmentIndex',
                meta: { title: '量具部门清单', classify: 'department', icon: 'department',isHistoryNav:1, affix: true, isShow: 1,authClassify: "department" }
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/department/detail'),
                name: 'departmentDetail',
                meta: { title: '量具部门详情', classify: 'department', icon: 'department',isHistoryNav:0, affix: true, isShow: 1,authClassify: "department" }
            }
        ])
    },
])

const manufacturerRoutes = filterByKey([
    {
        path: '/manufacturer',
        component:platform,
        redirect: '/manufacturer/index',
        name: "manufacturer",
        meta: { title: '制造厂商', classify: 'manufacturer', icon: 'manufacturer', affix: true,isHistoryNav:1, isShow: 1 ,authClassify: "manufacturer" },
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/manufacturer/index'),
                name: 'manufacturerIndex',
                meta: { title: '制造厂商清单', classify: 'manufacturer', icon: 'manufacturer',isHistoryNav:1, affix: true, isShow: 1,authClassify: "manufacturer" }
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/manufacturer/detail'),
                name: 'manufacturerDetail',
                meta: { title: '制造厂商详情', classify: 'manufacturer', icon: 'manufacturer',isHistoryNav:0, affix: true, isShow: 1,authClassify: "manufacturer" }
            }
        ])
    },
])

const teamRoutes = filterByKey([
    {
        path: '/team',
        component:platform,
        redirect: '/team/index',
        name: "team",
        meta: { title: '团队管理', classify: 'team', icon: 'team', affix: true,isHistoryNav:1,isShow: 0,role:9,authClassify:"team"},
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/team/index'),
                name: 'teamIndex',
                meta: { title: '团队管理', classify: 'team', icon: 'team', affix: true,isHistoryNav:1,isShow: 1 ,role:9,authClassify:"team"}
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/team/detail'),
                name: 'teamDetail',
                meta: {title: '团队详情', classify: 'team', icon: 'team', affix: true,isHistoryNav:0,isShow: 1,role:9,authClassify:"team"}
            },
        ])
    },
    {
        path: '/admin',
        component:platform,
        redirect: '/admin/index',
        name: "admin",
        meta: { title: '团队管理员', classify: 'admin', icon: 'admin', affix: true,isHistoryNav:1, isShow: 0 },
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/admin/index'),
                name: 'adminIndex',
                meta: { title: '管理员管理', classify: 'admin', icon: 'admin',isHistoryNav:1, affix: true, isShow: 1}
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/admin/detail'),
                name: 'adminDetail',
                meta: { title: '管理员详情', classify: 'admin', icon: 'admin',isHistoryNav:0, affix: true, isShow: 1 }
            }
        ])
    },
])

const systemRoutes = filterByKey([
    {
        path: '/boss',
        component: platform,
        redirect: '/boss/index',
        name: "boss",
        meta: {title: '平台管理员', classify: 'boss', icon: 'boss', affix: true,isHistoryNav:1, level: 2, role: 2, isShow: 1,authClassify:"boss"},
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/boss/index'),
                name: 'bossIndex',
                meta: {title: '平台管理员', classify: 'boss', icon: 'boss', affix: true, isHistoryNav:1,level: 2, role: 2, isShow: 1,authClassify:"boss"}
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/boss/detail'),
                name: 'bossDetail',
                meta: {title: '添加/编辑管理员', classify: 'boss', icon: 'boss', affix: true,isHistoryNav:0, level: 2, role: 2, isShow: 1,authClassify:"boss"}
            }
        ])
    },
    {
        path: '/bossAuth',
        component: platform,
        redirect: '/bossAuth/index/0',
        name: "bossAuth",
        meta: {title: '授权管理', classify: 'bossAuth', icon: 'bossAuth', affix: true,isHistoryNav:1, level: 2, role: 2, isShow: 1,authClassify:"bossAuth"},
        children: filterByKey([
            {
                path: 'index/:id',
                component: () => import('@/views/bossAuth/index'),
                name: 'bossAuthIndex',
                meta: {title: '授权管理', classify: 'bossAuth', icon: 'bossAuth', affix: true,isHistoryNav:1, level: 2, role: 2, isShow: 1,authClassify:"bossAuth"}
            },
            {
                path: 'options',
                component: () => import('@/views/bossAuth/options'),
                name: 'bossAuthOptions',
                meta: {title: '分类选项管理', classify: 'bossAuth', icon: 'bossAuth', affix: true,isHistoryNav:0, level: 2, role: 2, isShow: 1,authClassify:"bossAuth"}
            }
        ])
    },
    {
        path: '/system',
        component:platform,
        redirect: '/system/index',
        name: "system",
        meta: { title: '系统配置', classify: 'system', icon: 'system', affix: true,isHistoryNav:1, isShow: 0,authClassify:"system" },
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/system/index'),
                name: 'systemIndex',
                meta: { title: '系统配置', classify: 'system', icon: 'system', affix: true,isHistoryNav:1, isShow: 1,authClassify:"system" }
            },
        ])
    },
])

const constantRoutes = [
    ...openRoutes,
    ...importRoutes,
    ...toolsRoutes1,
    ...employeeRoutes,
    ...emailRoutes,
    ...deviceRoutes,
    ...deviceOneRoutes,
    ...deviceTwoRoutes,
    ...deviceThreeRoutes,
    ...taskRoutes,
    ...departmentRoutes,
    ...manufacturerRoutes,
    ...teamRoutes,
    ...systemRoutes
];

const router = createRouter({
    history: createWebHashHistory(),
    routes: constantRoutes
});

//TODO: 先实现下一级的过滤，
function filterByKey(arrayObj){
    arrayObj = arrayObj.filter((item)=>{
        return item["meta"]["isShow"] !== 0
    });

    return arrayObj
}

export {
    openRoutes,
    importRoutes,
    toolsRoutes1,
    employeeRoutes,
    emailRoutes,
    deviceRoutes,
    deviceOneRoutes,
    deviceTwoRoutes,
    deviceThreeRoutes,
    taskRoutes,
    departmentRoutes,
    manufacturerRoutes,
    teamRoutes,
    systemRoutes,
    constantRoutes,
    router
}